import { defineNuxtPlugin, useRouter } from '#imports'
import { getConfig } from '@b2ag/micro-front-tools'

export default defineNuxtPlugin({
  name: 'apm-agent',
  enforce: 'pre',
  parallel: false,
  async setup(nuxtApp) {
    if (import.meta.server) {
      const nodeApm = await import('elastic-apm-node')
      const { getServerSideTransaction } = await import('@invivodf/elastic-apm-rum/dist/nuxt')

      const serverSideTransaction = getServerSideTransaction(nodeApm.default || nodeApm)
      // eslint-disable-next-line no-param-reassign
      ;(nuxtApp.payload as Record<string, unknown>).apm = { transaction: serverSideTransaction?.transaction }
    } else if (import.meta.browser) {
      if (window.location.hostname.includes('localhost')) return

      const config = {
        serviceName: getConfig('APM_SERVICE_NAME'),
        serverUrl: getConfig('APM_SERVER_URL') || 'http://localhost:8200',
        serviceVersion: getConfig('APM_SERVICE_VERSION') || getConfig('VERSION'),
        active: getConfig('APM_IS_ACTIVE') === 'yes',
        environment: getConfig('APP_CONTEXT'),
        distributedTracingOrigins: [getConfig('AUTH0_AUDIENCE')],
        breakdownMetrics: true,
        pageLoadTraceId: `${(nuxtApp.payload as Record<string, any>).apm?.transaction?.traceId}`,
        pageLoadSpanId: `${(nuxtApp.payload as Record<string, any>).apm?.transaction?.spanId}`,
        transactionSampleRate: getConfig('APM_TRANSACTION_SAMPLE_RATE') || 0.1,
      }

      const { initVuePlugin } = await import('@invivodf/elastic-apm-rum/dist/vuejs/plugin')

      initVuePlugin(config, nuxtApp.vueApp, useRouter(), (nuxtApp.payload as Record<string, any>).apm?.transaction)
    }
  },
})
